import * as firebase from 'firebase/app';
import 'firebase/firestore';

import { EXERCISES } from 'utils/constants/collectionNames';
import {
  GET_EXERCISES_SUCCEED,
  GET_EXERCISES_ERROR,
  LOADING_STATE
} from './types';

// get client from Firebase
export const getExercises = () => async dispatch => {
  try {
    dispatch({ type: LOADING_STATE });
    let firestore = firebase.firestore();
    let queryRef = firestore
      .collection(EXERCISES)
      .where('is_preset', '==', true);
    return queryRef.onSnapshot(querySnapshot => {
      let exercises = [];
      if(querySnapshot.docs.length > 0) {
        querySnapshot.forEach(function(doc) {
          exercises.push({
            ...doc.data(),
            id: doc.id
          });
        });
        dispatch({ type: GET_EXERCISES_SUCCEED, payload: exercises });
      } else {
        dispatch({ type: GET_EXERCISES_SUCCEED, payload: [] });
      }
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_EXERCISES_ERROR,
      payload: `error: ${err}`
    });
  }
};
